export const SET_CLASS = 'SHOW_CLASS/SET_CLASS'
export const SET_CLASS_SCHEDULE = 'SHOW_CLASS/SET_CLASS_SCHEDULE'
export const SET_ARRAY_CLASS_SCHEDULE = 'SHOW_CLASS/SET_ARRAY_CLASS_SCHEDULE'
export const SET_SHOW_CLASS_DIALOG = 'SHOW_CLASS/SET_SHOW_CLASS_DIALOG'
export const SET_SHOW_CLASS_TIME_DIALOG = 'SHOW_CLASS/SET_SHOW_CLASS_TIME_DIALOG'